export default "__VITE_PUBLIC_ASSET__cb9d1ba8__"